import { FoodList } from '@/components/FoodList';

export const ChatBubble = ({ msg }) => {
  if (msg.role === 'user') {
    return (
      <div className="flex justify-end">
        <div
          className="max-w-[85%] rounded-2xl rounded-br-md bg-primary text-primary-foreground px-4 py-2.5 shadow-sm"
          data-testid="chat-bubble-user"
        >
          <p className="text-base whitespace-pre-wrap">{msg.text}</p>
        </div>
      </div>
    );
  }
  const isResult = msg.kind === 'result';
  return (
    <div className="flex justify-start">
      <div
        className="max-w-[85%] rounded-2xl rounded-bl-md bg-card border border-border px-4 py-3 shadow-sm"
        data-testid="chat-bubble-assistant"
      >
        {msg.foods?.length > 0 && (
          <div className="min-w-[230px]">
            <FoodList foods={msg.foods} showCarbs={isResult} />
          </div>
        )}
        {isResult && (
          <div className="mt-2 rounded-xl bg-primary text-primary-foreground px-4 py-3 flex items-center justify-between gap-6">
            <span className="text-base font-semibold">Total</span>
            <span className="text-2xl font-bold" data-testid="result-total">
              {msg.total != null ? `${msg.total} g` : '—'}
            </span>
          </div>
        )}
        {msg.text && (
          <p
            className={`text-base ${msg.foods?.length > 0 || isResult ? 'mt-2 text-muted-foreground' : 'font-medium'}`}
            data-testid="agent-message"
          >
            {msg.text}
          </p>
        )}
      </div>
    </div>
  );
};

export const TypingBubble = () => (
  <div className="flex justify-start" data-testid="typing-indicator">
    <div className="rounded-2xl rounded-bl-md bg-card border border-border px-4 py-3.5 shadow-sm flex items-center gap-1.5">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="h-2 w-2 rounded-full bg-muted-foreground/50 animate-bounce"
          style={{ animationDelay: `${i * 150}ms` }}
        />
      ))}
    </div>
  </div>
);
